import { Backdrop, Stack, Zoom } from "@mui/material";
import Lottie from "lottie-react";
import loadingText from "../assets/loadingText.json";
import loading from "../assets/loading.json";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

const Loading = () => {
  const showLoading = useSelector((state) => state?.sys.showLoading);
  const data = useSelector((state) => state?.biz?.data);
  const [open, setOpen] = useState(true);

  useEffect(() => {
    if (showLoading) setOpen(true);
    else {
      const timer = setTimeout(() => {
        setOpen(false);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [showLoading]);

  return (
    <Backdrop
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 500,
        "&.MuiBackdrop-root": {
          bgcolor: data ? "rgba(0 , 0, 0, 0.1)" : "white",
          backdropFilter: "blur(2px)",
        },
      }}
      open={open}
    >
      <Zoom in={open}>
        <Stack
          bgcolor="white"
          alignItems="center"
          justifyContent="center"
          borderRadius={100}
          paddingTop={1}
          paddingX={1}
          maxWidth={170}
        >
          <Lottie animationData={loading} loop={true} />
          {!data ? <Lottie animationData={loadingText} loop={true} /> : null}

        </Stack>
      </Zoom>
    </Backdrop>
  );
};
export default Loading;
